import { IUser } from '../interfaces/user.interface';


export abstract class JwtUtil {
  public static parse(token: string): IUser | null {
    try {
      const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');

      const data = JSON.parse(this.b64DecodeUnicode(base64));

      const team = typeof data.team === 'string' ? [data.team] : data.team;
      const modules = typeof data.modules === 'string' ? [data.modules] : data.modules;
      const teamAdmin = typeof data.team_admin === 'string' ? [data.team_admin] : data.team_admin;
      // ClaimTypes.Role landt meestal als "role"; zonder outbound-map als
      // lange URI. Array als er ooit meerdere rollen in het token zitten.
      const rawRole = data.role
        ?? data['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
      const role = Array.isArray(rawRole) ? rawRole[0] : rawRole;

      return {
        sid: data.nameid,
        activated: true,
        club: undefined,
        club_id: data.club_id || '',
        club_logo: data.club_logo || '',
        club_name: data.club_name || '',
        email: data.email,
        firstName: data.given_name,
        lastName: data.family_name,
        role,
        languageKey: data.language,
        phone: null,
        avatar: data.avatar,
        action: data.action,
        team: team,
        created: data.created,
        modules: modules,
        loggedIn: new Date().toISOString(),
        home_club: data.home_club || undefined,
        home_club_name: data.home_club_name || undefined,
        impersonated_by: data.impersonated_by || undefined,
        viewed_by: data.viewed_by || undefined,
        team_admin: teamAdmin ?? [],
      };
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  private static b64DecodeUnicode(str: string) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

}
